export const enum VerificationStatusTypeEnum {
  Verified = "Verified",
  Unverified = "Unverified",
}
